import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const initialForm = {
  name: "",
  email: "",
  organization: "",
  objective: "",
};

export const FounderContact = () => {
  const [form, setForm] = useState(initialForm);
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSubmitting(true);
    try {
      await axios.post(`${API}/enquiries`, form);
      toast.success("Enquiry sent", {
        description:
          "Thank you. Your message has been routed to Christopher Ortega.",
      });
      setForm(initialForm);
    } catch (error) {
      toast.error("Enquiry failed", {
        description: "Something went wrong sending your message. Please try again.",
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section
      id="founder"
      data-testid="founder-section"
      className="py-24 md:py-32 px-6 lg:px-12 bg-grove-ground"
    >
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <p className="font-mono text-xs uppercase tracking-widest text-grove-mid mb-2">
            03 / Leadership &amp; Contact
          </p>
          <h2 className="font-disp text-3xl md:text-5xl text-grove-ink mb-6">
            Direct Inquiries
          </h2>
          <p className="text-sm text-grove-mute leading-relaxed mb-6">
            equitygrove is currently in private preview. For bespoke analyst
            deployment, fund integrations, or platform demonstrations, speak
            directly with the founder.
          </p>

          <div
            data-testid="founder-card"
            className="p-6 rounded-xl bg-grove-panel border border-grove-panelline mb-6"
          >
            <div className="font-mono text-xs text-grove-mid uppercase tracking-wider mb-1">
              Founder &amp; Principal
            </div>
            <div className="font-disp text-2xl text-grove-ink font-semibold">
              Christopher Ortega
            </div>
            <div className="text-xs text-[#526359] mt-1">
              Founder, equitygrove
            </div>
          </div>
        </div>

        <div className="lg:col-span-7">
          <form
            id="contact"
            data-testid="contact-form"
            onSubmit={handleSubmit}
            className="p-8 md:p-10 rounded-2xl bg-white border border-grove-bstrong shadow-lg"
          >
            <h3 className="font-disp text-2xl text-grove-ink mb-2">
              Request Access or Schedule Discussion
            </h3>
            <p className="text-xs text-[#6B7280] mb-8">
              Direct communications routed to Christopher Ortega.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-6">
              <div>
                <label
                  htmlFor="contact-name"
                  className="block font-mono text-xs text-[#374151] uppercase tracking-wider mb-2"
                >
                  Your Name
                </label>
                <input
                  type="text"
                  id="contact-name"
                  name="name"
                  required
                  data-testid="contact-name-input"
                  placeholder="Jane Doe"
                  value={form.name}
                  onChange={handleChange}
                  className="w-full px-4 py-3 text-sm bg-grove-inputbg border border-grove-inputline rounded focus:outline-none focus:border-grove-deep text-grove-ink"
                />
              </div>
              <div>
                <label
                  htmlFor="contact-email"
                  className="block font-mono text-xs text-[#374151] uppercase tracking-wider mb-2"
                >
                  Work Email
                </label>
                <input
                  type="email"
                  id="contact-email"
                  name="email"
                  required
                  data-testid="contact-email-input"
                  placeholder="name@fund.com"
                  value={form.email}
                  onChange={handleChange}
                  className="w-full px-4 py-3 text-sm bg-grove-inputbg border border-grove-inputline rounded focus:outline-none focus:border-grove-deep text-grove-ink"
                />
              </div>
            </div>

            <div className="mb-6">
              <label
                htmlFor="contact-organization"
                className="block font-mono text-xs text-[#374151] uppercase tracking-wider mb-2"
              >
                Institution / Role
              </label>
              <input
                type="text"
                id="contact-organization"
                name="organization"
                data-testid="contact-organization-input"
                placeholder="Equity Research / Asset Management / Private Investor"
                value={form.organization}
                onChange={handleChange}
                className="w-full px-4 py-3 text-sm bg-grove-inputbg border border-grove-inputline rounded focus:outline-none focus:border-grove-deep text-grove-ink"
              />
            </div>

            <div className="mb-8">
              <label
                htmlFor="contact-objective"
                className="block font-mono text-xs text-[#374151] uppercase tracking-wider mb-2"
              >
                Research Objective
              </label>
              <textarea
                id="contact-objective"
                name="objective"
                rows="4"
                data-testid="contact-objective-input"
                placeholder="Tell us about your coverage universe or workflow requirements..."
                value={form.objective}
                onChange={handleChange}
                className="w-full px-4 py-3 text-sm bg-grove-inputbg border border-grove-inputline rounded focus:outline-none focus:border-grove-deep text-grove-ink resize-none"
              ></textarea>
            </div>

            <button
              type="submit"
              data-testid="contact-submit-btn"
              disabled={submitting}
              className="w-full py-4 bg-grove-deep text-white font-medium text-sm rounded hover:bg-grove-mid transition-all shadow-md disabled:opacity-60 disabled:cursor-not-allowed"
            >
              {submitting ? "Sending..." : "Submit Founder Enquiry"}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};
